/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const FilterOperator = zod.union([zod.literal(0),zod.literal(1),zod.literal(2),zod.literal(3),zod.literal(4),zod.literal(5),zod.literal(6),zod.literal(7),zod.literal(8),zod.literal(9),zod.literal(10),zod.literal(11),zod.literal(12),zod.literal(13)]);

export type FilterOperator = zod.input<typeof FilterOperator>;
export type FilterOperatorOutput = zod.output<typeof FilterOperator>;
